import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasMenuComponent } from './gas-menu.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasVerticalMenuComponent } from './vertical-menu/gas-vertical-menu.component';
import { GasContextMenuComponent } from './context-menu/gas-context-menu.component';
import { GasContextMenuDirective } from './context-menu/gas-context-menu.directive';
import { GasClickOutsideDirectiveModule } from '../../utils/click-outside-directive/gas-click-outside.module';
import { GasNavigationElementComponent } from './navigation-element/gas-navigation-element.component';
import { GasScrollModule } from '../../utils/gas-scroll/gas-scroll.module';

const COMPONENTS = [
  GasMenuComponent,
  GasVerticalMenuComponent,
  GasContextMenuComponent,
  GasNavigationElementComponent,
];

const DIRECTIVES = [
  GasContextMenuDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    GasContextMenuComponent,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasClickOutsideDirectiveModule,
    GasScrollModule,
  ],
})
export class GasMenuModule { }
